import { Injectable } from '@angular/core';
import { SearchService } from 'formbird-services';

@Injectable({
    providedIn: 'root'
})
export class DropDownConfigService {

    constructor(private searchService: SearchService) { }

    public async searchConfigList(configName, fieldName, templateId) {
        let searchOptions: any = {
            page: 0,
            pageSize: 10000,
            filter: {
                'query': {
                    'bool': {
                        'filter': [
                            { 'term': { 'relatedTemplateRel.documentId': templateId } },
                            { 'term': { 'appTags': 'componentConfiguration' } }
                        ]
                    }
                }
            }
        };

        try {
            const response = await this.searchService.search(searchOptions);
            let result = [];
            if (response?.data?.hits?.hits?.length) {
                const conf: any = response.data.hits.hits
                    .map(f => JSON.parse(f._source[configName]))
                    .filter(f => Object.keys(f).includes(fieldName));
                if (conf.length) result = conf[0][fieldName];
            }

            if (!result && result.length === 0) {
                console.warn('Component configuration with documentId:' + templateId + ' not found!');
            }

            return result;
        } catch (err) {
            throw new Error("Error on searching config: " + err.message);
        }
    }

}